module.exports = __webpack_public_path__ + "img/knowledge-base.1e5b51ef.svg";